import { IContract, IOnboarding } from '@sdk/contracts';

import { RequestService } from '../request';

export class UserOnboardingService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  public getMyUserOnboarding = async () => {
    return this.fetcher<IOnboarding>(`/user-onboarding`);
  };

  public getUserOnboardingByUserId = async (userId: string) => {
    return this.fetcher<IOnboarding>(`/user-onboarding/${userId}`);
  };

  public generateContract = async () => {
    return this.poster<IContract, void>(`/user-onboarding/contract`);
  };

  public markContractAsSigned = async () => {
    return this.putter(`/user-onboarding/contract/sign`);
  };

  public removeContract = async (userId: string) => {
    return this.deleter(`/user-onboarding/${userId}/contract`);
  };

  public finishUserOnboarding = async () => {
    return this.putter(`/user-onboarding/finish`);
  };

  public updateUserOnboarding = async (userId: string, userOnboarding: Partial<IOnboarding>) => {
    return this.putter<IOnboarding, Partial<IOnboarding>>(
      `/user-onboarding/${userId}`,
      userOnboarding
    );
  };
}
